var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_INVENTORY = (storeId) => `api/store/${storeId}/inventory`;
export const getInventory = function (storeId, queryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.get(`${GET_SET_INVENTORY(storeId)}?${queryParams}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getInventory:', error);
            throw error;
        }
    });
};
export const getInventoryById = function (storeId, id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_SET_INVENTORY(storeId)}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching getInventoryById:', error);
            throw error;
        }
    });
};
export const getHistoryById = function (storeId, id, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            let queryParams = '';
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('pageNum')) {
                queryParams += `pageNum=${params === null || params === void 0 ? void 0 : params.pageNum}`;
            }
            if (params === null || params === void 0 ? void 0 : params.hasOwnProperty('limit')) {
                queryParams += `&limit=${params === null || params === void 0 ? void 0 : params.limit}`;
            }
            const response = yield this.axiosInstance.get(`${GET_SET_INVENTORY(storeId)}/${id}/history?${queryParams}`, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching getInventoryHistory:', error);
            throw error;
        }
    });
};
